import React from 'react';

export default function MicButton({ state, onClick }) {
  // state: 'idle' | 'listening' | 'processing' | 'disabled'
  const classMap = {
    idle: 'mic-btn mic-idle',
    listening: 'mic-btn mic-listening',
    processing: 'mic-btn mic-processing',
    disabled: 'mic-btn mic-off',
  };

  const labelMap = {
    idle: 'اضغط للتحدث',
    listening: 'جارٍ الاستماع… (اضغط للإيقاف)',
    processing: 'جارٍ المعالجة…',
    disabled: 'انتهى الاختبار',
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20, flexWrap: 'wrap', marginBottom: 12 }}>
      <button
        className={classMap[state] || classMap.idle}
        onClick={onClick}
        disabled={state === 'processing' || state === 'disabled'}
        title="Tap to speak"
      >
        🎤
      </button>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--tx)' }}>
          {labelMap[state] || labelMap.idle}
        </div>
        <div style={{ fontSize: 11, color: 'var(--mu)', marginTop: 2 }}>
          The examiner will hear your voice answer
        </div>
      </div>
    </div>
  );
}
